import React from "react";

const Contact = () => {
  return (
    <section
      name="contact"
      id="contact"
      className="w-full md:h-screen bg-[#0a192f] flex justify-center py-10 px-3"
    >
      <form
        id="my-form"
        method="POST"
        action="https://getform.io/f/4850b88a-fda4-49c3-8e22-ae457347d1d5"
        className="flex flex-col max-w-[600px] w-full h-full"
      >
        <div className="pb-8 text-center mt-12">
          <h3 className="text-4xl font-bold inline text-gray-300">
            Contact <span className="text-primary-color">Me</span>
          </h3>
          <p className="text-gray-300 py-4">
            Submit the form below or shoot me an email at -{" "}
            {
              <a
                href="mailto:ayush123ngp@gmail.com"
                className="cursor-pointer underline"
              >
                ayush123ngp@gmail.com
              </a>
            }
          </p>
        </div>
        <input
          className="bg-[#ccd6f6] p-2 rounded-lg"
          type="text"
          placeholder="Name"
          name="name"
        />
        <input
          className="my-4 p-2 bg-[#ccd6f6] rounded-lg"
          type="email"
          placeholder="Email"
          name="email"
        />
        <textarea
          className="bg-[#ccd6f6] p-2 rounded-lg"
          name="message"
          rows="10"
          placeholder="Message"
        ></textarea>
        <button
          className="text-white border-2 hover:bg-primary-color px-4 py-3 my-8 mx-auto flex items-center"
          onClick={() => document?.getElementById("my-form")?.reset()}
        >
          Let's Collaborate
        </button>
      </form>
    </section>
  );
};

export default Contact;
